import React from 'react'
import Bg_Image from '../Common/Bg_Image';
// import moment from 'moment'
// import { Container, Row, Col, Form, Label, Input, Button } from 'reactstrap';
// import Link from 'gatsby-link'

class HeroImage extends React.Component {

  constructor(props) {
    super(props);
  }


  render() {

    // Expects featured_meda prop
    const ImageSharp = this.props.imageSharp;

    return (

      <div className={`hero-background ${this.props.className}`}>
          <Bg_Image 
            resolutions={ImageSharp.resolutions} 
            sizes={ImageSharp.sizes}
            className="hero-background-image"
            fadeIn={true}
          />
      </div>

    )
  }
}

export default HeroImage

HeroImage.defaultProps = {
  className: '',
}


// WEBPACK FOOTER //
// ./src/components/Common/Hero_Image.jsx